const TONES = 6;

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] ?? "?";
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? "") : "";
  return (first + last).toUpperCase();
}

/** The same person always gets the same colour. */
function tone(seed: string): number {
  let hash = 0;
  for (const char of seed) hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  return (hash % TONES) + 1;
}

/** Initials in a coloured circle. Decorative: the name is always shown or labelled nearby. */
export function Avatar({ name, seed, size = "md" }: { name: string; seed?: string; size?: "sm" | "md" }) {
  const classes = ["avatar", `avatar-tone-${tone(seed ?? name)}`, size === "sm" ? "avatar-sm" : ""].filter(Boolean).join(" ");
  return (
    // Initials are drawn by CSS (::before), so they're decoration, not text that a button's
    // accessible name would have to repeat (WCAG 2.5.3, label in name).
    <span className={classes} data-initials={initials(name)} aria-hidden="true" />
  );
}
